/* eslint-disable no-console */
/* eslint-disable no-undef */
import React, { useState, useRef } from "react";
import Formsy from "formsy-react";
import { observer } from "mobx-react";

import { createStyles, makeStyles } from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";

import DateTimeInput from "../../components/forms/inputs/DateTimeInput";
import SubmitButtonInput from "../../components/forms/inputs/SubmitButtonInput";
import TextfieldInput from "../../components/forms/inputs/TextfieldInput";

const useStyles = makeStyles(theme =>
  createStyles({
    formContainer: {},
    formItem: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    }
  })
);

function OneClickCalibrationForm(
  { _notifications, room },
  { _validationErrors }
) {
  const classes = useStyles();
  const form = useRef(null);
  const [loading, setLoading] = useState(false);
  const [validForm, setValidForm] = useState(false);
  const [work, setWork] = useState(0);
  const [progress, setProgress] = useState(0);

  const handleSubmit = async model => {
    setLoading(true);
    setWork(room.potential_sensor_groups.length);
    setProgress(0);

    await room
      .calibrateRoom({
        slope: Number(model.slope),
        start_timestamp: model.start_timestamp.unix()
      })
      .then(() => {
        // refresh room readings + sensor group measurements
        room.pullReadings().then(() => {
          Promise.all(
            room.potential_sensor_groups.map(sg =>
              sg.sensors.map(s =>
                s.pullMeasurements().then(() => setProgress(p => p + 1))
              )
            )
          );
        });
      });

    setLoading(false);
  };

  return (
    <>
      {loading && (
        <LinearProgress
          variant="determinate"
          value={(progress * 100.0) / work}
        />
      )}
      <Formsy
        ref={form}
        onValidSubmit={handleSubmit}
        onValid={() => setValidForm(true)}
        onInvalid={() => setValidForm(false)}
      >
        <Grid
          className={classes.formContainer}
          container
          alignContent="flex-start"
          alignItems="center"
        >
          <Grid className={classes.formItem} item sm={12}>
            <TextfieldInput
              value={0.000007291666666666667}
              name="slope"
              label="Slope"
              required
            />
          </Grid>
          <Grid className={classes.formItem} item sm={12}>
            <DateTimeInput
              value={null}
              name="start_timestamp"
              label="Start Timestamp"
              elementProps={{
                format: "MM/DD/YYYY hh:mm:ss"
              }}
              required
            />
          </Grid>
          <Grid className={classes.formItem} item sm={12}>
            <SubmitButtonInput
              name="submit"
              contents="Save"
              validForm={validForm}
              loading={loading}
              elementProps={{
                color: "primary"
              }}
            />
          </Grid>
        </Grid>
      </Formsy>
    </>
  );
}

export default observer(OneClickCalibrationForm);
